import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { take } from 'rxjs/operators';
import { LogService } from 'src/app/services/log.service'
import { OnReset, Transitions } from './transition.service.helpers';
import { Subject } from 'rxjs';
import { PublicEditProfileInfo } from 'src/app/store/performers.era'
import { Store } from '@ngrx/store';
import { JoiEvent } from 'globals/store/events.data'
import { ShareableInfoKeyMap, ShareableItemType, ShareableInfo, ShareableItem, CreateEditProfileCodeData, CreateEditProfileType, ShareableItemTypes, StandItemInfo, StandItemType, ShareableQuote, PublicEditEntityAssetsInfo, ShareableEntityAssets, PublicEditProfileStatusTypesType } from 'globals/store/share.data';
import { apiLink } from '../helpers/app-constants';
import { SubscriptionHelper } from './helpers/subscriptions.helper';
import * as firebase from 'firebase/app';
import { ShareableItemBase } from 'globals/store/share.data';
import { PublicQuoteInfo } from 'globals/store/reselectors/budget.data';
import { shareActions, shareFeature } from '../store/share.era';
import { collection, deleteDoc, doc, DocumentChange, DocumentData, Firestore, query, serverTimestamp, setDoc, updateDoc, where } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root' })
export class ShareService implements OnReset {
  readonly _file = 'share.service.ts'
  public $destroy_selected_event: Subject<boolean> = new Subject();
  public eventId: string
  public accountId: string

  onReset(resetType, value = null) {
    switch (resetType) {

      case Transitions.OnEnterEvent:
        // console.log('subscribing to shareables...')
        const { eventId, accountId } = value as JoiEvent
        this.eventId = eventId
        this.accountId = accountId
        return this.getShareablesForEvent()
      case Transitions.OnExitUser:
        // no break needed at the moment
      case Transitions.OnExitEvent:
        this.$destroy_selected_event.next(true)
        this.eventId = undefined // 
        this.accountId = undefined // 
        break
      default:
        break;
    }

  }

  constructor(
    private subscriptionHelper: SubscriptionHelper,
    private http:HttpClient,
    private log:LogService,
    public store: Store,
    private db: Firestore,
  ){ }

  async createSlugCode():Promise<string>{
    const url = apiLink + '/create-slug-code'
    return new Promise<string>((resolve, reject)=>{
      this.http.post(url,{}, { responseType: 'text' }).pipe( take(1) ).subscribe( (publishCode:string) =>{
        resolve(publishCode)
      }, response => {
        this.log.error({file:this._file, function:"createSlugCode", error:new Error() ,message:'Error obtaining unique code', response})
        reject('');
      })
    })
  }

  async 

  async createShareable(type:ShareableItemType, eventId:string, info?:ShareableInfo):Promise<ShareableItem>{
    const url = apiLink + '/create-shareable'
    return new Promise<ShareableItem>((resolve, reject)=>{
      const shareableItem: ShareableItemBase = { code: null, type, eventId, info }
      if (type === 'publish') shareableItem.accountId = this.accountId
      console.log({ shareableItem })
      this.http.post(url, shareableItem).pipe( take(1) ).subscribe( (shareable:ShareableItem) =>{
        resolve(shareable)
      }, response => {
        this.log.error({file:this._file, function:"createShareable", data:{type, eventId, info}, error:new Error() ,message:'Error obtaining unique code', response})
        reject();
      })
    })
  }

  getShareablesForEvent(){
    const wheres = [where('eventId', '==', this.eventId)]
    const q = query<any, DocumentData>(collection(this.db, 'shareables'), ...wheres)
    this.subscriptionHelper.subscribeToCollectionsWithHandlerAndStopper<ShareableItem>(q, 'shareables', this.handleShareableChangesFromDB.bind(this), this.$destroy_selected_event, this._file, 'getShareablesForEvent')
  }

  async getPublishShareablesFromAccountId(accountId: string, destroyEventList: Subject<boolean>) {
    console.log(`Getting publish shareables for account [${accountId}]`)
    const wheres = [where('accountId', '==', accountId), where('type', '==', 'publish'), where('info.status', '==', 'published')]
    const q = query<any, DocumentData>(collection(this.db, 'shareables'), ...wheres)
    await this.subscriptionHelper.subscribeToCollectionsWithHandlerAndStopper<ShareableItem>(q, 'shareables', this.handleShareableChangesFromDB.bind(this), destroyEventList)
    console.log(`Done getting publish shareables for account [${accountId}]`)
    return
  }

  handleShareableChangesFromDB(changes:DocumentChange<ShareableItem>[]){
    const toDelete = changes.filter(change => change.type === 'removed').map((change:DocumentChange<ShareableItem>)=> change.doc.data())
    const toAddOrUpdate = changes.filter(change => change.type !== 'removed').map((change:DocumentChange<ShareableItem>)=> change.doc.data())
    toDelete.forEach(shareableItem => {
      let key
      if (shareableItem.info) {
        key = shareableItem.info[ShareableInfoKeyMap[shareableItem.type]]
        if (!key) console.log("UPDATE THE SHAREABLE INFO KEY MAP", { shareableItem, ShareableInfoKeyMap, infoKey: ShareableInfoKeyMap[shareableItem.type] })
      } else {
        key = shareableItem.code
      }
      console.log(shareableItem )
      this.store.dispatch(shareActions.removeShareable(key, shareableItem.type))
      if (shareableItem.type === 'publish') {
        this.store.dispatch(shareActions.removeShareable(shareableItem.code, 'published_data'))
      }
    })
    if (toAddOrUpdate.length) {
      this.store.dispatch(shareActions.loadOrUpdateShareables(toAddOrUpdate))
    }
  }

  async deleteShareable(id: string) {
    await deleteDoc(doc(this.db, '/shareables/' + id));
  }

  updateProfileInfo(update:PublicEditProfileInfo | PublicEditEntityAssetsInfo){
    console.log({ update })
    try{
      updateDoc(doc(this.db, '/shareables/' + update.code), { info: update })
    }catch(response) {
      this.log.error({ file:this._file, function:'updateProfileInfo', message:'There was an error updating the status', data:{update}, error: new Error(), response} )
    }
  }

  async setEntityAssetsShareable(info: PublicEditEntityAssetsInfo): Promise<boolean> {
    const shareable: ShareableEntityAssets = {
      eventId: info.eventId,
      code: info.code,
      type: 'entityAsset',
      info
    }
    console.log({ info, shareable })
    try {
      await setDoc(doc(this.db, '/shareables/'+ shareable.code), shareable)
      return true
    } catch(response) {
      this.log.error({ file:this._file, function:'setEntityAssetsShareable', message:'There was an error updating the status', data: { shareable }, error: new Error(), response} )
      return false
    }
  }

  async generateShareCode() {
    const url = `${apiLink}/generate-share-code`
    try {
      const code = await this.http.post(url, {}, { responseType: 'text'}).pipe(take(1)).toPromise()
      console.log({ code })
      return code
    } catch (error) {
      console.log(error)
      this.log.error({
        file:this._file,
        function:'generateShareCode',
        error,
        message:`There was an error creating a code`,
      })
    }
  }


  async deleteQuoteInfo(quoteId: string) {
    await this.deleteShareable(quoteId)
  }

  async upsertPublicQuoteInfo(quoteData: PublicQuoteInfo) {
    const url = `${apiLink}/upsert-public-quote-info`;
    const shareable: ShareableQuote = { type: 'quote', info: quoteData, code: quoteData.quoteId, eventId: quoteData.eventId, accountId: quoteData.accountId }

    try {
      await this.http.post(url, shareable).pipe(take(1)).toPromise()
    } catch (error) {
      console.log(error)
      this.log.error({
        file:this._file,
        function:'upsertPublicQuoteInfo',
        error,
        data: quoteData,
        message:`There was an error upserting public quote info`,
      })
    }
  }

  async createEditProfileCode(entityId: string, eventId: string, entityType: CreateEditProfileType) {
    const url = `${apiLink}/create-edit-profile-code`;
    const data: CreateEditProfileCodeData = { entityId, eventId, entityType }
    console.log({ data, entityId, eventId, entityType })
    try {
      await this.http.post(url, data).pipe(take(1)).toPromise()
    } catch (error) {
      this.log.error({
        file:this._file,
        function:'createEditProfileCode',
        error,
        data:{ entityType, entityId },
        message:`There was an error creating a code for this ${entityType}`,
      })
    }
  }

  async addNewSessionStandShareable(standId: string, exhibitorId: string, type: StandItemType) {
    if (!ShareableItemTypes[type]) return console.log("ADDING AN INVALID TYPE: " + type, { ShareableItemTypes: ShareableItemTypes })
    const id = await this.createSlugCode()
    const shareSessionTypeInfo: StandItemInfo = {
      id,
      key: standId + "_" + (exhibitorId ? exhibitorId : ''),
      standId,
      exhibitorId,
      status: 'Active',
    }
    try {
      const insertObject:ShareableItem = {
        type,
        code: id,
        info: shareSessionTypeInfo,
        eventId: this.eventId,
        accountId: this.accountId,
        timestamp: serverTimestamp()
      }
      console.log({ shareSessionTypeInfo, insertObject })
      await setDoc(doc(this.db, '/shareables/' + id), insertObject)
    } catch (error) {
      this.log.error({
        file:this._file,
        data: shareSessionTypeInfo,
        function:'addNewSessionStandShareable',
        message:'There was an error updating the event',
        error
      })
    }
  }

  async upsertShareInfo(updateObject: Partial<ShareableItem>, id: string) {
    await updateDoc(doc(this.db, '/shareables/' + id), updateObject)
    return true
  }

}
